package br.com.texeratx.boardgametimeapp.core.spotify.di

import br.com.texeratx.boardgametimeapp.core.spotify.api.SpotifyPlayerApi
import br.com.texeratx.boardgametimeapp.core.spotify.api.SpotifyApi
import br.com.texeratx.boardgametimeapp.core.spotify.auth.SpotifyAuthManager
import br.com.texeratx.boardgametimeapp.core.spotify.repository.SpotifyPlayerRepository
import br.com.texeratx.boardgametimeapp.ui.spotifydevices.SpotifyDevicesViewModel
import io.ktor.client.HttpClient
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import org.koin.dsl.module

val spotifyModule = module {
    single {
        HttpClient {
            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                })
            }
        }
    }

    single { SpotifyAuthManager(http = get(), storage = get()) }

    single { SpotifyApi(get(), get()) }
    single { SpotifyPlayerApi(get(), get()) }
    single { SpotifyPlayerRepository(get()) }

    // Voyager ScreenModel -> factory é o recomendado
    factory { SpotifyDevicesViewModel(get(), get()) }
}
